export default "__VITE_ASSET__Bth4mqsV__"